import type { GA4AnalyticsEvent } from '@/domain/shared/types';
import type { SearchResult } from '@/scopes/search/search/infrastructure/api/types';
import { formatLocations } from '@/scopes/search/search/infrastructure/api/searchResponseMapper';

export interface SearchFilterClickEventProps {
  element: 'checkbox' | 'radio button' | 'slider' | 'calendar' | 'participants selector';
  type: string;
  result: string | number | readonly string[] | undefined;
}

export function createSearchFilterClickEvent({
  element,
  type,
  result,
}: SearchFilterClickEventProps): GA4AnalyticsEvent {
  return {
    event: 'clickFilter',
    description: 'set filter on product listing',
    element,
    type,
    result: result?.toString().toLowerCase(),
    interaction: true,
  };
}

export function createSearchProductClickEvent(result: SearchResult): GA4AnalyticsEvent {
  const occupancy =
    (result.occupancyInfo?.adultsCount ?? 0) +
    (result.occupancyInfo?.childrenCount ?? 0) +
    (result.occupancyInfo?.babiesCount ?? 0);
  return {
    event: 'eec.impressionClick',
    ecommerce: {
      click: {
        actionField: {
          list: 'search result',
        },
        products: [
          {
            id: result.id,
            name: result.name,
            category: formatLocations(result.locations),
            badges: result.collection,
            accoStars: result.rating,
            rating: result.userRating,
            entryPrice: result.price?.averagePrice,
            campaignId: result.campaign?.id,
            campaignName: result.campaign?.title,
            countryId: result.locations[0].deskId,
            regionId: result.locations[1].deskId,
            cityId: result.locations[2].deskId,
            list: 'search result',
            duration: result.featuredFilters?.duration,
            totalGuests: occupancy,
            departureDate: result.departureDateDetail,
          },
        ],
      },
    },
  };
}
